import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const LeMonde: React.FC = () => (
  <div style={{
    minHeight: '100vh',
    background: '#0a0a0a',
    color: '#222',
    fontFamily: "'Inter', Arial, Helvetica, sans-serif",
    display: 'flex',
    flexDirection: 'column'
  }}>
    <Header />
    <main style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start'
    }}>
      <div style={{
        maxWidth: 900,
        width: '100%',
        margin: '40px auto',
        background: '#fff',
        padding: 32,
        borderRadius: 8,
        boxSizing: 'border-box',
        boxShadow: '0 2px 12px rgba(0,0,0,0.07)'
      }}>
        <h1 style={{ color: '#0a3d62', marginTop: 0, marginBottom: 12 }}>
          Scandale environnemental au Brésil : Accor mise en cause dans une affaire de déchets toxiques à Belém
        </h1>
        <div style={{ color: '#888', fontSize: '0.95em', marginBottom: 24 }}>
          Le Monde | Octobre 2025
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <img
            src="/images/logo/le_globe.jpg"
            alt="Déchets toxiques à Belém"
            style={{
              width: '100%',
              maxWidth: 700,
              borderRadius: 8,
              margin: '20px 0'
            }}
          />
        </div>
        <p>
          Le reportage met en lumière l’implication présumée du groupe français Accor, dans un système de gestion illégale de déchets à Belém, capitale de l’État du Pará. Selon l’enquête, la société de collecte Lev Descartes, partenaire de l’hôtel, aurait déversé des déchets toxiques près de cours d’eau urbains, contaminant le sol et exposant des centaines d’habitants à des maladies respiratoires et dermatologiques.
        </p>
        <p>
          L’affaire, largement relayée par des ONG locales et internationales, est désormais au centre d’une enquête civile ouverte par le Ministère public du Pará pour crime environnemental, négligence sanitaire et racisme environnemental.
        </p>
        <p>
          Le journal rappelle que le scandale survient à quelques semaines de la COP, où le Brésil espère afficher un rôle de leader en matière de transition écologique. L’affaire ternit l’image de la multinationale française, d’autant plus que l’organisme de certification environnementale Green Key a exigé des explications immédiates sous peine de retrait de son label.
        </p>
        <blockquote style={{
          borderLeft: '4px solid #0a3d62',
          margin: '16px 0 0 0',
          paddingLeft: 16,
          color: '#444',
          fontStyle: 'italic'
        }}>
          Des militants français interrogés par Le Monde dénoncent un « double standard » :<br />
          « Une multinationale dont le siège est à Paris ne peut pas profiter de marchés dans le Sud global au détriment de la santé de communautés vulnérables », souligne une représentante d’ONG.
        </blockquote>
        <p>
          L’article conclut que cette crise met en évidence les défis persistants du Brésil en matière de gestion des déchets et interroge la responsabilité des entreprises étrangères dans la surveillance de leurs sous-traitants.
        </p>
      </div>
    </main>
    <Footer />
  </div>
);

export default LeMonde;